import React from 'react';
import {
  Box,
  TextField,
  Button,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Fab,
  IconButton,
  InputAdornment,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

export const EmployeeListBox = ({ handleAdd, formik }) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
          // 휴대폰: 한 줄 = 검색 키워드 + 검색어(돋보기로 검색) + 미사용, 추가는 오른쪽 아래 둥근 버튼
          flexWrap: { xs: 'nowrap', sm: 'wrap' },
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: { xs: 'contents', sm: 'flex' },
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            rowGap: 1,
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box sx={{ order: { xs: 2, sm: 0 }, flex: { xs: '0 0 auto', sm: '0 1 auto' }, alignSelf: { xs: 'flex-end', sm: 'auto' }, mb: { xs: 0.75, sm: 0 } }}>
            <FormControlLabel
              id="searchYn"
              name="searchYn"
              label="미사용"
              sx={{
                mr: { xs: 0, sm: 2 },
                '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap', fontSize: { xs: 13, sm: '1rem' } },
                '& .MuiCheckbox-root': { p: { xs: 0.5, sm: 1.125 } },
              }}
              control={
                <Checkbox
                  checked={formik.values.searchYn}
                  onChange={formik.handleChange}
                />
              }
            />
          </Box>
          <Box
            sx={{
              order: { xs: 1, sm: 0 },
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: 0,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: { xs: 'nowrap', sm: 'wrap' },
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': {
                m: { xs: 0.5, sm: 1 },
                width: { sm: '25ch' },
              },
              '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
              '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색 키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              {/* <MenuItem value="">검색키워드</MenuItem> */}
              <MenuItem value="usrNm">이름</MenuItem>
              <MenuItem value="usrNo">사번</MenuItem>
              <MenuItem value="dptNm">부서</MenuItem>
              <MenuItem value="gradeNm">직급</MenuItem>
              <MenuItem value="telNo">연락처</MenuItem>
              <MenuItem value="emlAddr">이메일</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                // 휴대폰에서는 검색 버튼 대신 돋보기(엔터와 같음)
                endAdornment: (
                  <InputAdornment position="end" sx={{ display: { xs: 'flex', sm: 'none' } }}>
                    <IconButton type="submit" size="small" aria-label="검색" disabled={formik.isSubmitting} edge="end">
                      <SearchIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
        {/* 사원 등록은 서버(POST /api/v1/user/info)가 관리자만 허용한다 - 비관리자는
            handleAdd를 안 받으므로(컨테이너가 isAdmin일 때만 넘김) 버튼 자체가 안 보인다.
            보안 배치 2(권한, 2026-10-27). */}
        {handleAdd && (
          <>
            <Box textAlign="center" sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Button color="primary" variant="contained" onClick={handleAdd}>
                추가
              </Button>
            </Box>
            <Fab
              color="primary"
              aria-label="추가"
              onClick={handleAdd}
              sx={{
                display: { xs: 'flex', sm: 'none' },
                position: 'fixed',
                right: 16,
                bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
                zIndex: (theme) => theme.zIndex.speedDial,
              }}
            >
              <AddIcon />
            </Fab>
          </>
        )}
      </Box>
    </div>
  );
};
